<template>
  <div class="business">
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
    <div class="title">
     <p>个人中心</p>
     <div class="title_content">
       <div class="title_img">
         <img :src="userImage" alt="">
       </div>
       <div class="title_name">
          <span>昵称：{{nickName}}</span>
          <span>状态：{{ ifYg ? '员工' : '访客'}}</span>
       </div>
     </div>
     <div class="header">
      <span class="active " @click="changeHeightF()">关注网站</span>
      <span @click="changeHeight()">账号管理</span>
    </div>
    </div>
    <div class="mask" v-show="actPro" @click="hidePro"></div>
    <div class="switchSite" v-if="ifLogin && tabshow">
      <div class="nxsite insite" @click="nxsite()">逆行监控网站</div>
      <div class="mesite" @click="mesite()">我的监控网站</div>
    </div>
 
    <div class="content">
      <div class="content_box">
        <div class="concern show" ref="concernH">
          <div v-for="(item,index) in webs" :key="index" class="webN">
            <p>{{item.name}}</p>
            <span class="content_app"><span>网站地址：</span>{{item.address}}</span>
            <span class="content_app"><span>状态码：</span>{{item.resCode}}</span>
            <span class="content_app"><span>响应速度：</span>{{item.resTime}}</span>
            <span class="content_app"><span>网站地址2：</span>{{item.address2}}</span>
            <span class="content_app"><span>状态码2：</span>{{item.resCode2}}</span>
            <span class="content_app"><span>响应速度2：</span>{{item.resTime2}}</span>
            <span class="tableLike"><img :src=getLike(item) class=""  @click='likes(index, $event)' alt /></span>
          </div>
          <div v-show='dataLength' class="nData">
            <img :src="noData" alt="">
            <div style="color:#ccc;font-size:14px;">当前无关注的网站</div>
          </div>
          <div v-show="!ifLogin" class="noData">
            <!-- <img :src="noneData" alt=""> -->
          </div>
          <p v-show="!ifLogin">您还未登录，请先<router-link :to="{name:'login'}">登陆</router-link></p>
        </div>


        <div class="manage hide">
          <div v-if="!ifLogin" class="noData">
            <!-- <img :src="noneData" alt=""> -->
          </div>
          <p v-if="!ifLogin">您还未登录，请先<router-link :to="{name:'login'}">登陆</router-link></p>
          <table v-if="ifLogin">
            <tr>
              <td>设置</td>
              <td></td>
              <td>操作</td>
            </tr>
            <tr>
              <td>退出登录</td>
              <td></td>
              <td>
                <button  class="update" @click="loginOut">退出登录</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <MobileNav></MobileNav>
  </div>
</template>

<script>
import axios from 'axios'
import MobileNav from '../MobileNav'
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");
import { outLogin,setUserInfo } from '@/js/utils'
export default {
  components: {
    MobileNav,
  },
  data() {
    return {
      showTime: '',
      staff:[],
      thisPage:[],
      pageTotal: null,
      pageNum: 1,
      pageCount: 5,  
      report:[],
      projects:[],
      like:[],
      likeweb:[],
      web:[],
      webs:[],
      reports: '',
      projected:'',
      actPro: false,
      qc:[],
      proOn:-1,
      noData:require("../../assets/noData.png"),
      dataLength:false,
      firstShow: true,
      loadingShow:true,
      projectData:{
        name: '',
        start_date:'',
        predict_test_date:'',
        test_date:'',
        end_date:''
      },
      curHeight:'',
      adds: false,
      tabshow: true,
      isPc: true,
      scroll_top: 0
    }
  },
  mounted() {
    var me = this
    me.loadingShow = true;
    me.curHeight = document.documentElement.clientHeight || document.body.clientHeight;
    me.getShowTime()
    me.quchong()
    me.staffnames()
    me.staffReport()
    me.likewebs()
    me.tab()
    setInterval(me.getShowTime, 1000)
    if (me.$store.state.likeweb.length === 1) {
        me.dataLength = true;
      }
    if (!me.ifLogin) {
      setTimeout(function(){
        me.loadingShow = false;
      },500)
    }
    if (this.isMobile) {
      this.isPc = true
    } else {
      this.isPc = false
    }
  },
  sockets:{
    connect:function(){
      var token=localStorage.getItem('jwt')
      if(token){
        this.$socket.emit('authenticate',{token})
      }
    },
    staffReport:function(data){
      if (data[0]) {
        if(this.ifLogin && this.ifYg){
          if (data[0].report) {
           this.report = data[0].report.split('\n日期')[0].trim();
          }
        }
      }
    },

  

    nameStaff:function(data){
      if(this.ifLogin){
        this.like=data[0].likeweb.split(',').map(Number)
      }
      for(var i=0;i<this.like.length;i++){
        if(this.like[i]==0){
          continue;
        }
        this.likeweb.push(this.like[i])
      }
    },
    likeWeb:function(data){
      this.web.push(data[0])
      var w=[];
      var obj={};
      for(var i =0; i<this.web.length; i++){
        if (this.web[i]) {
          if(!obj[this.web[i].id]){
              w.push(this.web[i]);
              obj[this.web[i].id] = true;
          }
        }
      }
      this.webs=w
    },
    userSite:function(data){
      this.web.push(data[0])
      var w=[];
      var obj={};
      for(var i =0; i<this.web.length; i++){
        if (this.web[i]) {
          if(!obj[this.web[i].id]){
              w.push(this.web[i]);
              obj[this.web[i].id] = true;
          }
        }
      }
      this.webs=w
    },
    authenticated:function(data){
      var token = localStorage.getItem('jwt');
      this.$socket.emit('queryUser',token)
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/" });
      }
    },
    userInfo:function(data){
      var that=this;
      setUserInfo.call(this, data)
      that.quchong();
      that.staffReport();

      that.likewebs();
      that.tab();
      setTimeout(function(){
        that.loadingShow = false;
      },500)
    },
    changeLike:function(data){
      this.$store.state.likeweb = data.split(',').map(Number);
      this.dataLength = false;
      if (this.$store.state.likeweb.length === 1) {
        this.dataLength = true;
      }
    }
  },
  methods: {

    tab(){
      var me = this;
      var spans = document.querySelectorAll(".header span")
      var divs = document.querySelectorAll(".content_box>div")
      console.log('spans :>> ', spans);
      console.log('divs :>> ', divs);
      if(!this.ifYg){
        divs[1].style.display='none'
        divs[2].style.display='none'
      }
      for(var i = 0; i < spans.length; i++){
          spans[i].setAttribute("data-id",i)
          spans[i].onclick = function () {
            for (var j = 0; j < spans.length;j++){
            spans[j].classList.remove("active")
            divs[j].classList.remove("show")
            divs[j].classList.add("hide")
          }
          this.classList.add("active")
          var index = this.getAttribute("data-id")
          divs[index].classList.add("show")
          divs[index].classList.remove("hide")
        }
      }
      setTimeout(function(){
        me.loadingShow = false;
      },500)
    },
    quchong(){
      var me=this;
      me.qc = [];
      if (!this.adds) {
        for(var i=0;i<me.$store.state.likeweb.length;i++){
          if(me.$store.state.likeweb[i]==0){
            continue;
          }
          me.qc.push(me.$store.state.likeweb[i])
        }
      }else {
        for(var i=0;i<me.$store.state.userSite.length;i++){
          if(me.$store.state.userSite[i]==0){
            continue;
          }
          me.qc.push(me.$store.state.userSite[i])
        }
      }
    },
    staffnames(){
      this.$socket.emit('nameStaff',{
       userName:this.$store.state.userName
      }); 
    },
    staffReport(){
      var me = this;
      me.$socket.emit("staffReport", {
        userName: this.$store.state.userName
      });
    },

    likewebs(){
      var me=this;
      this.web = [];
      for(var i=0;i<this.$store.state.likeweb.length;i++){
        me.$socket.emit('likeWeb',{
          id:me.qc[i]
        })
      }
    },
    userlikewebs(){
      var me=this;
      this.web = [];
      for(var i=0;i<this.$store.state.userSite.length;i++){
        me.$socket.emit('userSite',{
          id:me.qc[i]
        })
      }
    },
    getShowTime() {
      var me = this
      var nowTime = new Date()
      var year = nowTime.getFullYear()
      var month = nowTime.getMonth() + 1
      var date = nowTime.getDate()
      var hour = nowTime.toLocaleTimeString()
      me.showTime = year + '-' + month + '-' + date + ' ' + hour
    },
    handleCurrentChange(val){
      var me=this;
      me.pageNum=val;
    },
    loginOut() {
      outLogin.call(this)
      localStorage.setItem('Lo', 2);
    },
    actPros(e,index,data){
      //禁止滚动
      // var int = document.getElementsByClassName("content")[0];
      // int.style.touch = 'none;'
      document.body.style.overflow = "hidden";
      document.body.style.position = "relative";
      var pro = document.getElementsByClassName("editPro")[0];
      pro.style.position = 'absolute;'
      pro.style.left = '60%;'
      pro.style.top = '45%'
      // window.scrollTo(0,0);
      this.proOn = e;
      this.actPro = !this.actPro;
      this.projectData = data;
      if (this.projectData.run_date.length === 0) {
        this.projectData.run_date = [
          {
            run_start_date: '',
            run_end_date: '',
            id: 1
          }
        ]
      }
    },
    hidePro(){
      this.actPro = !this.actPro;
      document.body.style.overflow = "auto";
      var pro = document.getElementsByClassName("editPro")[0];
      pro.scrollTo(0,0);

    },
    getLike(item) {
      if (!this.adds) {
        if (this.$store.state.likeweb) {
          return this.$store.state.likeweb.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.likeweb) {
          return unlikeImg;
        }
      }else{
        if (this.$store.state.userSite) {
          return this.$store.state.userSite.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.userSite) {
          return unlikeImg;
        }
      }
    },
    likes(index, evt){
      if(!this.ifLogin){
        this.$router.push('/')
      }
      else{
        if (!this.adds) {
          if(this.$store.state.likeweb.indexOf(this.webs[index].id) == -1){
            this.$store.commit('addlikeWeb',this.webs[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deletelikeWeb',this.webs[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
            var webN = document.getElementsByClassName("webN")[index];
            webN.style.display = 'none';
          }
        }else {
          if(this.$store.state.userSite.indexOf(this.webs[index].id) == -1){
            this.$store.commit('adduserSite',this.webs[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deleteuserSite',this.webs[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
            var webN = document.getElementsByClassName("webN")[index];
            webN.style.display = 'none';
          }
        }
      }
    },
    changeHeight(){
      var zh = document.getElementsByClassName('manage')[0]
      var pro = document.getElementsByClassName('project')[0]
      zh.style.zIndex = 10
      pro.style.zIndex = 1
      var int = document.getElementsByClassName("content")[0];
      int.style.height = '80vh';
      window,scrollTo(0,0);
      if (this.report.length === 0) {
        
      }
      this.tabshow = false;
    },
    changeHeightF(data){
      var zh = document.getElementsByClassName('manage')[0]
      var pro = document.getElementsByClassName('project')[0]
      zh.style.zIndex = 1
      pro.style.zIndex = 10
      var bodyHieght;
      window,scrollTo(0,0);
      if(data == 1){
        this.tabshow = false;
        bodyHieght = this.$refs.projectH.offsetHeight + 200;
      }else {
        this.tabshow = true;
        bodyHieght = this.$refs.concernH.offsetHeight + 200;
      }
      var int = document.getElementsByClassName("content")[0];
      int.style.height = bodyHieght+'px';
      if (this.report.length === 0) {
        
      }
    },
    editProject(data){
      // console.log('data',data)
      document.body.style.overflow = "auto";
      var pro = document.getElementsByClassName("editPro")[0];
      pro.scrollTo(0,0);
    
    },
    changeJP(){
        document.activeElement.blur();
    },
    editAddRunDateArray(){
      var me = this
      var text = {
        run_start_date: '',
        run_end_date: '',
        id: me.projectData.run_date.length + 1
      }
      me.projectData.run_date.push(text)
    },
    editdeleteRunDateArray(index){
      var me = this
      if (me.projectData.run_date.length > 1) {
        me.projectData.run_date.splice(index, 1)
      }
    },
    nxsite: function() {
      this.adds = false;
      this.quchong();
      document.getElementsByClassName("nxsite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("mesite")[0].style.color = '#ffffff';
      this.likewebs();
    },
    mesite: function() {
      this.adds = true;
      this.quchong();
      document.getElementsByClassName("mesite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("nxsite")[0].style.color = '#ffffff';
      this.userlikewebs();
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
   }
  },
  watch: {
    webs:function(){
      var me = this;
      me.$nextTick(function(){
        // console.log('111')
        var bodyHieght = me.$refs.concernH.offsetHeight + 200;
        var int = document.getElementsByClassName("content")[0];
        int.style.height = bodyHieght+'px';
      })
    }
  },
  computed:{
    nickName(){
      return this.$store.state.nickName;
    },
    ifLogin() {
      return this.$store.state.ifLogin;
    },
    unionId() {
      return this.$store.state.wxAppData
    },
    userName() {
      return this.$store.state.userName;
    },
    ifYg(){
      return this.$store.state.ifYg;
    },
    likewebss(){
      return this.$store.state.likeweb;
    },
    userImage(){
      return this.$store.state.userImage;
    },
  },
}
</script>

<style lang="less" scoped>
.business{
  padding-top: 70px;
    .mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1001;
    background-color: rgba(23, 23, 23, 0.8);
  }
  position: relative;
  .editPro{
    // position: relative;
    // top: 0;
    // left: 0;
    width: 100%;
    height: auto;
    position: fixed;
    left: 55%;
    // top: 50%;
    transform: translateX(-50%) translateY(-50%);
    overflow: scroll;
    .editBox{
      // z-index: 1002;
      position: absolute;
      width: 90%;
      min-height: 80%;
      // left: 50%;
      top: 10%;
      // transform: scale(0.8);
      // margin: auto;
      // margin-top: 30px;
      // margin-bottom: 64px;
      // margin-left: -45%;
      background: #181e26;
      border-radius: 3%;
      color: #fff;
      font-size: 16px;
      text-align: left;
      overflow: hidden;
      .editTitle{
        text-align: center;
        padding: 5px 0;
      }
      .editContent{
        padding: 15px 20px;
        div{
          padding: 3px 0;
          span{
            display: inline-block;
          }
          span:first-child{
            width: 180px;
          }
        }
        .editBtn{
          padding-top: 20px;
          text-align: right;
          span{
            width: 100px;
            text-align: right;
            button{
              width: 60px;
              height: 30px;
              padding: 8px 10px;
              color: #fff;
              background: #222a36;
              border: 0;
              box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 3px rgba(0, 0, 0, 0.12) !important;
            }
            button:hover{
              color: #21a2f5;
            }
          }
          span:first-child{
            width: 80px;
          }
        }
        .el-button{
          padding: 3px;
          margin-left: 5px;
        }
      }
    }
  }
  .editData{
    height: 600px;
    transition: all 1s;
  }
  .loading{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background-color: #181e26;
      .loadingImg{
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
  .title{
    height: 28vh;
    min-height: 180px;
    background-color:rgba(34, 42, 54);
    p{
      color:#fff;
      font-size: 18px;
      height: 5vh;
      margin-top: 2vh;
    }
    img{
      width: 60px;
      border-radius: 50%;
      // margin-top: -20px;
      // margin-bottom: -10px;
    }
    span{
      color:#fff;
      font-size: 14px;
      margin: 0;
    }
    .title_content{
      height: 13vh;
      min-height: 90px;
      div{
        display: inline-block;
        width: 50%;
        height: 100%;
      }
      .title_img{
        float: left;
      }
      .title_name{
        padding-left: 10%;
        span{
          display: block;
          text-align: left;
        }
      }
    }
  }
  .ysxy{
    color:#fff;
    font-size: 14px;
    text-decoration: none;
  }
  .header{
    display: flex;
    span{
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      flex: 1;
      color:#fff;
      font-size: 14px;
      &:hover{
        color:#4f86ed;
      }
    }
    .active{
      color:#4f86ed;
    }
  }
  .switchSite {
    width: 80vw;
    height: 40px;
    margin: 20px auto;
    align-self: center;
    line-height: 40px;
    text-align: left;
    position: relative;
    top: 21vh;
    margin-bottom: 0;
    font-size: 12px;
    z-index: 99;
    div {
      height: 30px;
      line-height: 25px;
      display: inline-block;
      cursor: pointer;
      border: 1px solid rgb(148, 146, 146);
      padding: 2px 5px;
      margin-right: 5%;
      border-radius: 10px;
      color: #fff;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
    }
    .insite{
      color: rgb(33, 162, 245);
    }
  }
  .content{
    margin-top: 155px;
    margin-bottom: 40px;
    width: 92vw;
    min-height: 120vh;
    margin: 0 auto;
    position: relative;
    overflow: hidden;

    .content_box{
      width: 100%;
    }
    .concern{
      width: 92vw;
      padding: 5vw 0;
      .noData{
        text-align: center;
        box-shadow: none;
        background-color: transparent;
        img{
          width: 200px;
          height: 200px;
        }
      }
      .nData{
        box-shadow: none;
        background-color: transparent;
        margin-top: -3vh;
        div{
          box-shadow: none;
          background-color: transparent;
          color: #ccc;
          text-align: center;
          padding: 0;
          padding-right: 8%; 
        }
      }
      p{
          color:#fff;
          font-size: 14px;
          a{
            padding-left: 3px;
            color: cornflowerblue;
          }
        }
      div{
        background-color: #20252f;
        text-align: left;
        margin-bottom: 10px;
        padding:10px 0;
        border-radius: 10px;
        box-shadow: 0 0 5px #000;
        position: relative;
        width: 90vw;
        left: 5.5vw;
        p{
          color:#fff;
          font-size: 16px;
          margin:0;
          padding:0;
          padding-left: 10px;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-bottom: 2px solid #10141a;
        }
        .content_app{
          display: block;
          color:#fff;
          font-size: 12px;
          padding: 2px 0 2px 10px;
          border-bottom: 1px solid #666;
          span{
            width: 27%;
            min-width: 78px;
            display: inline-block;
            font-size: 13px;
          }
        }
        .content_app:nth-child(odd){
          background: rgba(117, 176, 243, 0.3);
        }
      }
      .tishi{
        color:#fff;
        font-size: 14px;
      }
    }
    .report{
      width: 91vw;
      left: 0.5vw;
      // margin:auto;
      p{
        color:#fff;
        font-size: 18px;
      }
      .zb pre{
        background-color: #20252f;
        padding:10px 0 10px 10px;
        border-radius: 10px;
        text-align: left;
        font-size: 14px;
        white-space:pre-wrap;
        word-wrap:break-word;
        box-shadow: 0px 0px 20px #000;
      }
    }
    .project{
      width: 91vw;
      left: 0.5vw;
      padding: 3vh 0;
      div{
        background-color: #20252f;
        text-align: left;
        margin-bottom: 10px;
        padding:10px 0 10px 0px;
        border-radius: 10px;
        box-shadow: 0 0 10px #000;
        p{
          width: 80%;
          color:#aaa;
          font-size: 14px;
          margin:0;
          padding:0;
          padding-left: 10px;
          padding-bottom: 5px;
          border-bottom: 2px solid #10141a;
        }
        span{
          color:#fff;
          font-size: 14px;
          display: block;
        }
        .edit{
          display: inline-block;
          width: 100%;
          padding-left: 10px;
          padding-top: 5px;
          span{
            display: inline-block;
            margin-left: 60%;
            cursor: pointer;
          }
        }
        .project_app:nth-child(odd){
          background: rgba(117, 176, 243, 0.3);
        }
        .project_app{
          display: block;
          color:#fff;
          font-size: 12px;
          padding: 2px 0 2px 10px;
          border-bottom: 1px solid #666;
          span{
            width: 40%;
            min-width: 98px;
            display: inline-block;
            font-size: 13px;
          }
        }
      }
      .el-dropdown{
        box-shadow: none;
        margin: 0;
      }
      .proNData{
        padding: 0;
        box-shadow: none;
        background-color: transparent;
        text-align: center;
        div{
          box-shadow: none;
          background-color: transparent;
          text-align: center;
          margin: 0;
          padding: 0;
        }
      }
    }
    .manage{
      width: 91vw;
      left: 0.5vw;
      padding: 5vw 0;
      .noData{
        text-align: center;
        box-shadow: none;
        background-color: transparent;
        img{
          width: 200px;
          height: 200px;
          margin-top: 10px;
        }
      }
      p{
        color: #fff;
        font-size: 14px;
        a{
          padding-left: 3px;
          color: cornflowerblue;
        }
      }
      table{
        width: 100%;
        color:#fff;
        background-color: #20252f;
        border-collapse: collapse;
        border-spacing: 0;
        margin:auto;
        margin-bottom: 20px;
        box-shadow: 0px 0px 20px #000;
        border-radius: 10px;
        tr{
          border-bottom: 1px solid #666;
          td{
            width: 20%;
            height: 50px;
            font-size: 14px;
            button{
              line-height: 30px;
              font-size: 14px;
              border:0;
              outline: 0;
              cursor: pointer;
              background-color:#4f86ed;
              border-radius: 5px;
              color:#fff;
              width: 70px;
              &:hover{
                background-color: #68a5ff;
              }
            }
          }
        }
        tr:nth-child(1) td{
          color:#aaa;
          font-size: 14px;
        }
        tr:last-child{
          border-bottom: 0;
        }
        tr:nth-child(even){
          background: rgba(117, 176, 243, 0.3);
        }
      }
    }
    >div{
      >div{
        position: absolute;
        top: 22vh;
        opacity: 0;
        right: -110%;
      }
    }
    .show{
      animation: showlist 0.8s;
      animation-fill-mode: forwards;
    }
    .hide{
      animation: hidelist 0.8s;
      animation-fill-mode: forwards;
    }
    .tableLike{
      position: absolute;
      top: 5%;
      right: 5%;
      img{
        width: 25px;
        height: 25px;
        cursor: pointer;
      }

    }
  }
}
@keyframes showlist{
  0% { 
    opacity: 0;
    right: -100%;
  }
  50% {
    opacity: 1;
    right: 5%;
	}
	100% {
    opacity: 1;
    right: 5%;
    display: block;
	}  
}
@keyframes hidelist{
  0% { 
    opacity: 1;
    right: 5%;
    display: block;
  }
  50% {
    opacity: 0;
    right:-15%;
	}  
	100% {
    opacity: 0;
    right:-110%;
    display: none;
	}  
}


</style>




// WEBPACK FOOTER //
// src/components/mobile/mobileMe.vue